<template>
    <div class="popup" :class="classObj">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <div>{{ title }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div v-if="rechargeGiftType == 'firstRecharge'" class="main_content">
                    <div class="table">
                        <div class="tHeader">
                            <div class="w25P">{{ $t('depositRepeat.full') }}</div>
                            <div class="w25P">{{ $t('depositRepeat.RegisterFirstCharge') }}</div>
                            <div class="w25P">{{ $t('depositRepeat.DailyFirstCharge') }}</div>
                            <div class="w25P">{{ $t('depositRepeat.EachRecharge') }}</div>
                        </div>
                        <div class="tBody">
                            <div v-if="firstRechargeList.length">
                                <div class="tr" v-for="(item, index) in firstRechargeList" :key="index">
                                    <div>{{ item.rechargeAmt }}</div>
                                    <div>{{ item.handselRate }}%</div>
                                    <div>{{ item.firstHandselRate }}%</div>
                                    <div>{{ item.everyHandselRate }}%</div>
                                </div>
                            </div>
                            <div class="empty" v-else>
                                <img src="@/assets/common/empty.avif" alt="" class="empty_img">
                                <div>{{ $t("lang.NoData") }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="intro">
                        <div class="title">{{ $t('depositTotal.EventIntro') }}</div>
                        <div class="desc" v-html="rulesDesc"></div>
                    </div>
                </div>
                <div v-if="rechargeGiftType == 'repeatRecharge'" class="main_content">
                    <div v-for="(item, index) in repeatRechargeList" :key="index">
                        <div class="table-title">{{item.rechargeNumber}}{{ $t('depositRepeat.thRecharge') }}</div>
                        <div class="table">
                            <div class="tHeader H08r">
                                <div>{{ $t('depositRepeat.full') }}</div>
                                <div>{{ $t('depositRepeat.give') }}</div>
                            </div>
                            <div class="tBody">
                                <div v-if="item.repeatRechargeDetailVoList.length">
                                    <div class="tr" v-for="(citem, cindex) in item.repeatRechargeDetailVoList" :key="cindex">
                                        <div>{{ citem.rechargeAmt }}</div>
                                        <div>{{ citem.everyHandselRate }}%</div>
                                    </div>
                                </div>
                                <div class="empty" v-else>
                                    <img src="@/assets/common/empty.png" alt="" class="empty_img">
                                    <div>{{ $t("lang.NoData") }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="everyRechargeList.length">
                        <div class="table-title">{{ $t('depositRepeat.EveryRecharge') }}</div>
                        <div class="table">
                            <div class="tHeader H08r">
                                <div>{{ $t('depositRepeat.full') }}</div>
                                <div>{{ $t('depositRepeat.give') }}</div>
                            </div>
                            <div class="tBody">
                                <div v-if="everyRechargeList.length">
                                    <div class="tr" v-for="(item, index) in everyRechargeList" :key="index">
                                        <div>{{ item.rechargeAmt }}</div>
                                        <div>{{ item.everyHandselRate }}%</div>
                                    </div>
                                </div>
                                <div class="empty" v-else>
                                    <img src="@/assets/common/empty.png" alt="" class="empty_img">
                                    <div>{{ $t("lang.NoData") }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="intro">
                        <div class="title">{{ $t('depositRepeat.EventIntro') }}</div>
                        <div class="desc" v-html="rulesDesc"></div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUsdtRechargeGiftInfo } from '@/api/rechargeInfo'
export default {
    name: 'depositRepeatUsdt',
    components: {},
    data() {
        return {
            rechargeGiftType: 'firstRecharge',
            rulesDesc: '',
            firstRechargeList: [],
            repeatRechargeList: [],
            everyRechargeList: [],
            title: ''
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        eventId() {
            return this.$store.state.user.depositRepeatPopupUsdtEventId
        },
        show: {
            get() {
                return this.$store.state.user.isShowDepositRepeatUsdtPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() {
    },
    methods: {
        open() {
            this.init()
        },
        close() {
            this.$store.dispatch('user/setIsShowDepositRepeatUsdtPopup', { id: '', show: false })
        },
        init() {
            const eventId = this.eventId
            this.getInfo(eventId)
        },
        getInfo(id) {
            getUsdtRechargeGiftInfo({ id }).then((res) => {
                if (res.code) return
                const D = res.result
                this.rechargeGiftType = D.rechargeGiftType
                this.rulesDesc = D.eventContent // 规则说明
                this.title = D.eventName
                this.firstRechargeList = D.usdtFirstRechargeDetailVoList || []
                this.repeatRechargeList = D.usdtRepeatRechargeNumberDetailVoList || []
                this.everyRechargeList = D.usdtEveryRepeatRechargeDetailVoList || []
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile {

        .van-popup {
            &.van-popup--center {
                width: 88.6% !important;
                height: max-content !important;
                max-width: 9rem !important;
                min-height: 8.6rem !important;
                max-height: 64.5% !important;
            }

            .content {
                width: 100% !important;
                padding-bottom: .4rem;

                .header {
                    height: .94rem;
                    padding: 0 .28rem;

                    &>div:first-child {
                        font-size: .3rem;
                    }

                    .close {
                        font-size: .3rem;
                    }
                }

                .box {
                    padding: .3rem .3rem 0;

                    .main_content {
                        .info {
                            .item {
                                font-size: .24rem;

                                >div {

                                    &:last-child {
                                        font-size: .3rem;
                                    }
                                }
                            }
                        }

                        .table {
                            .tHeader {
                                height: .74rem;
                                font-size: 0.24rem;
                            }

                            .tBody {
                                // min-height: 2rem;

                                .tr {
                                    height: .54rem;

                                    &>div {
                                        font-size: 0.24rem;
                                    }
                                }

                                .empty {
                                    font-size: .28rem;

                                    .empty_img {
                                        width: 3.4rem;
                                        object-fit: contain;
                                    }
                                }
                            }
                        }

                        .intro {
                            border: .02rem solid $border-color;
                            font-size: .2rem;
                            padding: .2rem;

                            .title {
                                font-size: .24rem;
                                margin-bottom: .2rem;
                            }
                        }
                    }
                }
            }
        }
    }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            background: $bg-popup-color;
            width: 500px;
            height: 700px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding-bottom: 30px;

            .header {
                display: flex;
                height: 76px;
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: 20px;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-iconfont-color;
                    font-size: 16px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .main_content {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 20px 20px 0;
                overflow-y: scroll;

                .info {
                    display: flex;
                    justify-content: space-between;

                    .item {
                        background: $bg-component-disabled-surface-color;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        width: 48.5%;
                        height: 75px;
                        border-radius: .24rem;
                        color: $font-sub-color;
                        font-size: 15px;
                        text-align: center;

                        >div:last-child {
                            font-size: 23px;
                            color: $font-color;
                        }
                    }
                }
                .table-title{
                    text-align: left;
                    color: $font-color;
                    font-size: .32rem;
                    font-weight: bold;
                    margin-bottom: .1rem;
                }
                .table {
                    border-radius: 10px;
                    background-color: $bg-component-disabled-deep-color;
                    margin: 0 0 18px;
                    padding: 0.25rem;
                    padding-bottom: .06rem;

                    .tHeader {
                        color: $font-color;
                        font-size: 17px;
                        height: 1.2rem;
                        display: flex;
                        align-items: center;
                        // padding: 0 28px;
                        border: 1px solid $border-color;
                        border-radius: .24rem;

                        &.H08r{
                            height: .8rem;
                        }

                        &>div {
                            width: 50%;
                            text-align: center;
                            line-height: .28rem;

                            &.w25P {
                                width: 25%;
                            }
                        }
                    }

                    .tBody {
                        // padding: 0 28px;
                        // min-height: 3rem;
                        position: relative;

                        .tr {
                            display: flex;
                            align-items: center;
                            height: .6rem;

                            &:nth-child(2n) {
                                background: $bg-box-color;
                                border-radius: 12px;
                            }

                            &>div {
                                width: 50%;
                                color: $font-sub-color;
                                font-size: 15px;
                                text-align: center;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }

                        .empty {
                            // position: absolute;
                            // left: 50%;
                            // top: 50%;
                            // transform: translate(50%, 50%);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            color: $font-sub-color;
                            font-size: 16px;
                            text-align: center;
                            height: 3rem;

                            .empty_img {
                                width: 170px;
                                object-fit: contain;
                            }
                        }
                    }
                }

                .intro {
                    border: 2px solid $border-color;
                    color: $font-sub-color;
                    font-size: 12px;
                    text-align: left;
                    border-radius: .24rem;
                    padding: 10px;

                    .title {
                        background: linear-gradient(to bottom, #ff7e5f, #feb47b);
                        font-size: 16px;
                        margin-bottom: 10px;
                        font-weight: bold;
                        -webkit-background-clip: text;
                        background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    .desc {
                        color: $font-color;
                    }
                }
            }
        }
    }
}
</style>
